import Layout from '../Layout';

type SectionedLayoutProps = React.ComponentProps<typeof Layout> & {
  title?: string;
};

export default function SectionedLayout({
  children,
  title,
  ...props
}: Readonly<SectionedLayoutProps>) {
  return (
    <Layout customTitle={title} {...props}>
      {children}
    </Layout>
  );
}
